<template>
    <div>
        <div class="title-4 mb-24 text-uppercase font-700">Выберите способ получения заказа</div>

        <div class="d-flex flex-wrap mb-32" v-if="deliveries && deliveries.length">
            <div class="checkbox mb-12 mr-4" v-for="delivery in deliveries">
                <input :id="'delivery_' + delivery.id" :value="delivery" type="checkbox"
                       :disabled="delivery_disabled.indexOf( delivery.id) != -1"
                       @change="setDeliveryType(delivery)">
                <label :for="'delivery_' + delivery.id">{{delivery.f1}}</label>
            </div>
        </div>

        <!--  *** ДОСТАВКА *** -->
        <div class="mb-40" v-if="order.delivery_type.indexOf( 60129542270) != -1">
            <div class="title-4 mb-24">Укажите адрес доставки</div>

            <div class="row">
                <div class="col-sm-10">
                    <div class="input-box mb-3">
                        <label class="color-text-label" for="delivery_address_city">Город, улица, дом, кв*</label>
                        <input id="delivery_address_city" type="text" class="img-fluid"
                               v-model="order.delivery_address.city">
                    </div>

                    <div>
                        <div class="radio d-inline-block mb-2">
                            <input id="delivery_outside_1" value="1" type="radio"
                                   v-model="order.postData.delivery_outside">
                            <label @click="order.postData.delivery_outside_distance = null" for="delivery_outside_1"> В
                                пределах МКАД</label>
                        </div>
                    </div>

                    <div>
                        <div class="radio d-inline-block">
                            <input id="delivery_outside_2" value="2" type="radio"
                                   v-model="order.postData.delivery_outside">
                            <label for="delivery_outside_2"> за пределами МКАД</label>
                        </div>
                    </div>

                    <div class="input-box pt-3" v-if="order.postData.delivery_outside == 2">
                        <label class="color-text-label" for="delivery_outside_distance">Введите расстояние в километрах
                            от МКАД*</label>
                        <input v-mask="'####'" id="delivery_outside_distance" type="text" class="img-fluid"
                               v-model="order.postData.delivery_outside_distance">
                        <!--
                        <p v-if="order.postData.delivery_outside_distance && order.state.pick_up_as_delivery"
                            class="mb-2 small pt-1">
                            Предварительная стоимость доставки и увоза:
                            <span>{{order.postData.delivery_outside_distance * 2}} руб.</span>
                        </p>
                        -->
                        <!--
                        <p v-if="order.postData.delivery_outside_distance && !order.state.pick_up_as_delivery"
                            class="mb-2 small pt-1">
                            Предварительная стоимость доставки:
                            <span>{{order.postData.delivery_outside_distance}} руб.</span>
                        </p>
                        -->
                    </div>
                </div>
            </div>
        </div>

        <div v-if="order.delivery_type.indexOf(60129542271) != -1 && order.delivery_type.indexOf( 60129542270) != -1">
            <hr class="light">
        </div>

        <!--  *** УВОЗ *** -->
        <div v-if="order.delivery_type.indexOf(60129542271) != -1">
            <div class="title-4 mb-24">Укажите адрес увоза</div>

            <div class="checkbox mb-28" v-if="order.delivery_type.indexOf( 60129542270) != -1">
                <input id="pick_up_as_delivery" value="Увоз (от 16 BYN)" type="checkbox"
                       v-model="order.state.pick_up_as_delivery">
                <label for="pick_up_as_delivery">Совпадает с адресом доставки</label>
            </div>

            <div class="row" v-if="!order.state.pick_up_as_delivery">
                <div class="col-sm-10">
                    <div class="input-box mb-3">
                        <label class="color-text-label" for="pick_up_address_city">Город, улица, дом, кв*</label>
                        <input id="pick_up_address_city" type="text" class="img-fluid"
                               v-model="order.pick_up_address.city">
                    </div>

                    <div>
                        <div class="radio d-inline-block mb-2">
                            <input id="pick_up_outside_1" value="1" type="radio"
                                   v-model="order.postData.pick_up_outside">
                            <label @click="order.postData.pick_up_outside_distance = null" for="pick_up_outside_1"> В
                                пределах МКАД</label>
                        </div>
                    </div>

                    <div>
                        <div class="radio d-inline-block">
                            <input id="pick_up_outside_2" value="2" type="radio"
                                   v-model="order.postData.pick_up_outside">
                            <label for="pick_up_outside_2"> за пределами МКАД</label>
                        </div>
                    </div>

                    <div class="input-box pt-3" v-if="order.postData.pick_up_outside == 2">
                        <label class="color-text-label" for="pick_up_outside_distance">Введите расстояние в километрах
                            от МКАД*</label>
                        <input v-mask="'####'" id="pick_up_outside_distance" type="text" class="img-fluid"
                               v-model="order.postData.pick_up_outside_distance">
                        <!--
                        <div v-if="order.postData.pick_up_outside_distance" class="h5 mb-2">
                            Предварительная стоимость увоза:
                            <span>{{order.postData.pick_up_outside_distance * 1}} руб.</span>
                        </div>
                        -->
                    </div>
                </div>
            </div>
        </div>
        <hr>

        <div>
            <div class="title-4 text-uppercase mb-24 font-700">Выберите дополнительные услуги</div>

            <div class="row" v-if="services">
                <div v-for="item in services" class="col-xl-8 d-flex align-items-center justify-content-between">
                    <div class="checkbox mb-12 mr-4">
                        <input :id="item.id" :value="item" type="checkbox"
                               v-model="order.postData.services">
                        <label :for="item.id"> {{item.f1}}</label>
                    </div>

                    <div class="h5 mb-0 nowrap">от {{item.f2}} RUB</div>
                </div>
            </div>
        </div>

        <hr>

        <div>
            <div class="title-4 text-uppercase mb-24 font-700">Способ оплаты</div>

            <div class="title-4 mb-20">Когда статус заказа будет Подтвержден, вы сможете внести оплату:</div>

            <div class="d-flex flex-wrap mb-32">
                <div class="radio mb-12 mr-4">
                    <input id="payment_type_2" value="Наличными" type="radio"
                           v-model="order.postData.payment_type">
                    <label for="payment_type_2">Наличными</label>
                </div>
                <div class="radio mb-12 mr-4">
                    <input id="payment_type_3" value="Перевод по реквизитам" type="radio"
                           v-model="order.postData.payment_type">
                    <label for="payment_type_3">Перевод по реквизитам</label>
                </div>
                <div class="radio mb-12">
                    <input id="payment_type_4" value="Безналичный расчет" type="radio"
                           v-model="order.postData.payment_type">
                    <label for="payment_type_4">Безналичный расчет</label>
                </div>
            </div>

            <hr>
        </div>

        <div class="mb-40">
            <div class="title-4 text-uppercase mb-24 font-700">Комментарий к заказу</div>
            <div class="row">
                <div class="col-sm-10">
                    <div class="input-box">
                        <label class="color-text-label" for="delivery_note">Введите комментарий</label>
                        <textarea id="delivery_note" type="text" class="img-fluid"
                                  v-model="order.postData.delivery_note"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!user || (user && !user.userData.email)">
            <div class="title-4 text-uppercase mb-24 font-700">Уведомление о заказе</div>
            <div class="row">
                <div class="col-sm-10">
                    <div class="input-box">
                        <label class="color-text-label" :class="{'error-form': $v.order.postData.email.$error}"
                               for="email">Введите E-mail для получения заказа на почту</label>
                        <input style="border: 1px solid #fce01b;" id="email" type="email" class="img-fluid"
                               v-model.lazy="order.postData.email">
                        <p class="mb-0 small color-text-error pt-1" v-if="order.state.email_error">Данный пользоветель
                            уже есть в базе, обратитесь в тех. поддержку</p>
                    </div>
                </div>
            </div>
        </div>

        <hr>

        <div class="title-4 text-uppercase mb-24 font-700">Проверка заказа</div>
        <order-products @update="updateData" class="mb-32"></order-products>

        <div class="mb-32">
            <div class="checkbox">
                <input id="confirm" type="checkbox"
                       v-model="order.state.confirm">
                <label for="confirm">Я соглашаюсь на <a href="/rules" target="_blank" class="color-primary">условие
                    проката</a></label>
            </div>
        </div>

        <div class="attention-box"
             v-if="order.delivery_type.indexOf( 60129542270) != -1 || order.delivery_type.indexOf(60129542271) != -1">
            <p>Стоимость доставки может быть пересчитана при уточнении маршрута менеджером.</p>
        </div>
    </div>
</template>

<script>
    import order from '../../../../services/order';
    import state from '../../../../services/data';

    import {emailRule} from '../../../../services/validation';

    const touchMap = new WeakMap();

    export default {
        props: ['services', 'deliveries', 'user'],
        data() {
            return {
                order: order,
                state: state,

                delivery_disabled: [],
            }
        },

        mounted() {
            this.order.postData.delivery_type = [];
            this.order.delivery_type = [];

            this.delivery_disabled = [];

            this.order.postData.delivery_outside = '1';
            this.order.postData.delivery_outside_distance = null;
            this.order.postData.pick_up_outside = '1';
            this.order.postData.pick_up_outside_distance = null;

        },

        watch: {
            'order.state.pick_up_as_delivery'() {
                if (this.order.state.pick_up_as_delivery) {
                    this.order.postData.pick_up_outside_distance = this.order.postData.delivery_outside_distance;
                } else {
                    this.order.postData.pick_up_outside_distance = null;
                }
                this.state.setAdditionalCost();
            },

            'order.postData.delivery_type'() {
                this.order.state.pick_up_as_delivery = false;

                if (this.order.delivery_type.indexOf(60129542270) == -1) {
                    this.order.postData.delivery_outside = '1';
                    this.order.postData.delivery_outside_distance = null;
                }
                if (this.order.delivery_type.indexOf(60129542271) == -1) {
                    this.order.postData.pick_up_outside = '1';
                    this.order.postData.pick_up_outside_distance = null;
                }
                this.state.setAdditionalCost();

            },
            'order.postData.services'() {
                this.state.setAdditionalCost();
            },
            'order.postData.delivery_outside_distance'() {
                this.state.setAdditionalCost();
            },
            'order.postData.pick_up_outside_distance'() {
                this.state.setAdditionalCost();
            },
            'order.postData.email'() {
                this.checkEmail();
            }
        },

        methods: {
            updateData() {
                this.$emit('update', true)
            },

            setDeliveryType(delivery) {
                const post_delivery_type = this.order.postData.delivery_type.indexOf(delivery);
                if (post_delivery_type > -1) this.order.postData.delivery_type.splice(post_delivery_type, 1);
                else this.order.postData.delivery_type.push(delivery);

                const delivery_type = this.order.delivery_type.indexOf(delivery.id);
                if (delivery_type > -1) this.order.delivery_type.splice(delivery_type, 1);
                else this.order.delivery_type.push(delivery.id);

                if (this.order.delivery_type.indexOf(60129542270) != -1) {
                    this.delivery_disabled = [60129542253];
                } else if (this.order.delivery_type.indexOf(60129542253) != -1) {
                    this.delivery_disabled = [60129542270];
                } else this.delivery_disabled = [];
                this.state.setAdditionalCost();
            },

            checkEmail() {
                this.order.state.email_error = false;
                this.$v.order.postData.email.$touch();
                if (this.order.postData.email && !this.$v.order.postData.email.$invalid) {

                    //TODO вставить url запроса
                    let url = '/api/validate-email';
                    axios.post(url, {'email' : this.order.postData.email})
                        .then(response => {
                            if (response.status == 200) {
                                /*email есть в базе, ошибка*/
                                if (response.data.check === 'true') this.order.state.email_error = true
                            }
                        })
                }
                if (this.order.postData.email && this.$v.order.postData.email.$invalid) {
                    this.order.state.email_valid = false;
                }
            },

            delayTouch($v) {
                $v.$reset();
                if (touchMap.has($v)) {
                    clearTimeout(touchMap.get($v))
                }
                touchMap.set($v, setTimeout($v.$touch, 1000))
            }
        },

        validations: {
            order: {
                postData: {
                    email: emailRule
                }
            }
        }
    }
</script>
